import {Stack, styled, Tab, Tabs, Typography} from "@mui/material";
import {useState} from "react";
import type {PlannedPlaces} from "../../firebase/index.js";
import {red_900} from "../../reusables/js/APXTheme.js";
import PlaceList from "./PlaceList.jsx";


const ContainedTabs = styled(Tabs)({
	  "& .MuiTabs-indicator": {
			 backgroundColor: red_900,
			 border: 0.5
	  }
});

const ContainedTab = styled(Tab)({
	  backgroundColor: "black",
	  margin: "0.5px",
	  borderRadius: "8px 8px 0px 0px",
	  border: 2,
	  borderStyle: "solid",
	  borderColor: red_900,
	  color: "white",
	  "&.Mui-selected": {
			 borderColor: red_900,
			 backgroundColor: red_900,
			 color: "white"
	  }
});


export interface ItineraryPlannedProps {
	  plannedPlaces: PlannedPlaces;
}


export default function ItineraryPlanned({plannedPlaces}: ItineraryPlannedProps) {
	  const [tabIndex, setTabIndex] = useState(0);
	  return (
				 <>
						{
								  Object.keys(plannedPlaces).length === 0 &&
								  <Typography variant="h4" sx={{textAlign: "center", marginTop: 4}}>No dates set yet</Typography>
						}
						{
								  Object.keys(plannedPlaces).length > 0 &&
								  <>
										 <Stack>
												<ContainedTabs variant={"scrollable"} scrollButtons={"auto"} value={tabIndex}
																	onChange={(event, newValue) => setTabIndex(newValue)}>
													  {Object.keys(plannedPlaces).map((date, index) => {
															 return <ContainedTab key={index} value={index}
																						 label={new Date(Number(date)).toLocaleDateString("en-GB", {day: "numeric", month: "short", year: "numeric"})}
															 />;
													  })}
												</ContainedTabs>
										 </Stack>
										 <Stack>
												{Object.keys(plannedPlaces).map((date, index) => {
													  return tabIndex === index && <PlaceList key={index} basePlaces={plannedPlaces[date]}/>;
												})}
										 </Stack>
								  </>
						}
				 </>
	  );
}